module.exports = __webpack_public_path__ + "static/img/main.32d995b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/SAMURAISHODOWN/intro/main.jpg
// module id = Es9p
// module chunks = 0